import React, {useCallback , useMemo, useState, useEffect} from "react";
import {
  Main,
  Timeline,
  Expertise,
  Project,
  Contact,
  Navigation,
  Footer,
} from "./components";
import FadeIn from './components/FadeIn';
import './index.scss';
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadFull } from "tsparticles";
import {
    type Container,
    type ISourceOptions,
    MoveDirection,
    OutMode,
  } from "@tsparticles/engine";
  

function App() {
    const [mode, setMode] = useState<string>('dark');
    const [animateColor, setanimateColor] = useState<string>('#000000');
    const [init, setInit] = useState(false);
    const [seconds, setSeconds] = useState(0);
    useEffect(() => {
        initParticlesEngine(async (engine) => {
          // you can initiate the tsParticles instance (engine) here, adding custom shapes or presets
          // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
          // starting from v2 you can add only the features you need reducing the bundle size
          //await loadAll(engine);
          //await loadFull(engine);
          await loadFull(engine);
          //await loadBasic(engine);
        }).then(() => {
          setInit(true);
        });
      }, []);
    
      const particlesLoaded = async (container?: Container): Promise<void> => {
        console.log(container);
        container!.loadTheme("dark");
      };
    
      const options: ISourceOptions = useMemo(
        () => ({
            
              particles: {
                shape: {
                  type: "circle"
                },
                number: {
                  value: 0
                },
                color: {
                  value: "random"
                },
                opacity: {
                  value: 0.3
                },
                size: {
                  value: {min: 5, max: 20}
                },
                move: {
                  enable: true,
                  speed: 6,
                  random: false,
                  outModes: "bounce",
                }
              },
              absorbers: [
                {
                  zindex: -1,
                  position: { x: 50, y: 25, z: -1 },
                  color: {
                    value: "#808080"
                  },
                  size: {
                    value: 10,
                    limit: 100,
                  }
                }
              ],
              emitters: [
                {
                  direction: "top-right",
                  position: {
                    x: 0,
                    y: 100
                  },
                  rate: {
                    delay: 0.3,
                    quantity: 4,
                  },
                },
                {
                    direction: "top-left",
                    position: {
                      x: 100,
                      y: 100
                    },
                    rate: {
                      delay: 0.3,
                      quantity: 4,
                    },
                }
              ]
    }),
    [],
  );


    const handleModeChange = () => {
        if (mode === 'dark') {
            setMode('light');
            setanimateColor('#000000');
        } else {
            setMode('dark');
            setanimateColor('#FFFFFF');
        }
    }

    useEffect(() => {
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
      }, []);

    return (
    <div className={`main-container ${mode === 'dark' ? 'dark-mode' : 'light-mode'}`}>
        <Navigation parentToChild={{mode}} modeChange={handleModeChange}/>
        <Particles id="tsparticles" particlesLoaded={particlesLoaded} options={options}/>
        <FadeIn transitionDuration={700}>
            <Main/>
            <Expertise/>
            <Timeline/>
            <Project/>
            <Contact/>
        </FadeIn>
        <Footer />
    </div>
    );
}

export default App;